import React, { useEffect, useRef, useState } from "react";
import modalidades_trx from "../assets/Modalidades/modalidades_trx.png";
import modalidades_power from "../assets/Modalidades/modalidades_power.png";
import modalidades_kettle from "../assets/Modalidades/modalidades_kettlebell.png";
import modalidades_pilates from "../assets/Modalidades/modalidades_pilates.png";
import modalidades_personalizado from "../assets/Modalidades/modalidades_personalizado.png";

import "../css/Modalidades.css";

// Card Component with animation
const ModalidadeCard = ({ image, title, description, intensity, delay }) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), delay);
        }
      },
      { threshold: 0.1 },
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, [delay]);

  return (
    <div
      ref={cardRef}
      className={`modalidade-card ${isVisible ? "visible" : ""}`}
    >
      <div className="modalidade-image-wrapper">
        <img src={image} alt={title} className="modalidade-image" />
        <div className="modalidade-overlay">
          <span className="intensity-badge">{intensity}</span>
        </div>
      </div>
      <div className="modalidade-content">
        <h3 className="modalidade-title">{title}</h3>
        <p className="modalidade-description">{description}</p>
      </div>
    </div>
  );
};

const ModalidadesImages = () => {
  const modalidadesData = [
    {
      id: 1,
      image: modalidades_trx,
      title: "TRX",
      description:
        "Treino de suspensão que utiliza o peso corporal para desenvolver força, equilíbrio, flexibilidade e estabilidade do core simultaneamente.",
      intensity: "Alta Intensidade",
    },
    {
      id: 2,
      image: modalidades_power,
      title: "Power Circuit",
      description:
        "Circuito de alta intensidade que combina exercícios de força e cardio para maximizar a queima calórica e tonificação muscular.",
      intensity: "Alta Intensidade",
    },
    {
      id: 3,
      image: modalidades_kettle,
      title: "Kettlebell",
      description:
        "Treino funcional com kettlebells que trabalha força, resistência e coordenação através de movimentos dinâmicos e explosivos.",
      intensity: "Alta Intensidade",
    },
    {
      id: 4,
      image: modalidades_pilates,
      title: "Pilates em Grupo",
      description:
        "Método de exercício que fortalece o corpo de forma equilibrada, com ênfase no core, alinhamento postural e flexibilidade. Aulas às segundas e quartas, das 19h15 às 20h.",
      intensity: "Moderada",
    },
    {
      id: 5,
      image: modalidades_personalizado,
      title: "Treino Personalizado",
      description:
        "Programa individualizado e adaptado às suas necessidades, com acompanhamento exclusivo de profissionais certificados.",
      intensity: "Personalizada",
    },
  ];

  return (
    <div className="modalidades-grid">
      {modalidadesData.map((modalidade, index) => (
        <ModalidadeCard
          key={modalidade.id}
          image={modalidade.image}
          title={modalidade.title}
          description={modalidade.description}
          intensity={modalidade.intensity}
          delay={index * 100}
        />
      ))}
    </div>
  );
};

export default ModalidadesImages;
